import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Amount } from '@fcom/dapi';
import { FinnairTotalPricesDetails } from '@fcom/dapi/api/models/finnair-total-prices-details';
import { toAmount } from '@fcom/common-booking/utils/common-booking.utils';
import { hasUnitPrices } from '@fcom/common/utils/price-utils';

export enum GrandTotalTheme {
  DEFAULT = 'default',
  RENEWED = 'renewed',
}

@Component({
  selector: 'fin-grand-total',
  templateUrl: './grand-total.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GrandTotalComponent {
  readonly GrandTotalTheme = GrandTotalTheme;

  prices = input.required<FinnairTotalPricesDetails>();

  /**
   * Theme to be shown
   */
  theme = input(GrandTotalTheme.DEFAULT);

  useSymbol = input(false);

  totalPrice = computed<Amount | undefined>(() => {
    const prices = this.prices();
    return hasUnitPrices(prices)
      ? toAmount(prices.total.total.totalAmountPaid ?? prices.total.total.totalAmount)
      : undefined;
  });

  totalPoints = computed<number | null>(() => {
    const prices = this.prices();
    return prices?.total?.total?.totalPoints ? +prices.total.total.totalPoints.amount : null;
  });

  originalTotalPrice = computed<Amount | undefined>(() => {
    const prices = this.prices();
    return prices?.flight?.total?.discountReasonCode && prices?.total?.total?.originalTotalAmount
      ? prices.total.total.originalTotalAmount
      : undefined;
  });
}
